var _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1131,
    height: 200,
    viewBox: "0 0 1131 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.9543 0 20 0H1111C1122.05 0 1131 8.95431 1131 20V180C1131 191.046 1122.05 200 1111 200H20C8.95428 200 0 191.046 0 180V20Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_342_330",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1131,
    height: 200
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.9543 0 20 0H1111C1122.05 0 1131 8.95431 1131 20V180C1131 191.046 1122.05 200 1111 200H20C8.95428 200 0 191.046 0 180V20Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_342_330)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_342_330)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 411.703,
    cy: 86.3789,
    rx: 411.703,
    ry: 86.3789,
    transform: "matrix(0.784561 -0.620051 0.76452 0.644601 168.91 161.555)",
    fill: "#71D5F6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M492.299 -93.4C581.476 -163.878 669.59 -221.444 739.952 -257.543C775.138 -275.595 805.859 -288.266 830.041 -294.506C842.133 -297.626 852.56 -299.13 861.076 -298.908C869.59 -298.686 876.143 -296.742 880.57 -293.01C884.996 -289.278 887.165 -283.868 887.161 -276.915C887.157 -269.96 884.978 -261.501 880.767 -251.737C872.345 -232.209 855.837 -207.554 832.597 -179.431C786.121 -123.191 712.788 -53.1628 623.611 17.3152C534.434 87.7932 446.32 145.359 375.957 181.458C340.772 199.51 310.051 212.18 285.869 218.42C273.778 221.54 263.351 223.045 254.834 222.823C246.321 222.601 239.767 220.657 235.341 216.925C230.914 213.192 228.746 207.783 228.75 200.829C228.753 193.874 230.932 185.416 235.144 175.651C243.566 156.124 260.073 131.469 283.313 103.346C329.788 47.1061 403.122 -22.922 492.299 -93.4Z",
    stroke: "url(#paint0_linear_342_330)",
    strokeOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 384.099,
    cy: 112.378,
    rx: 384.099,
    ry: 112.378,
    transform: "matrix(0.77467 -0.632366 0.77467 0.632366 -29 121.782)",
    fill: "#FF97BB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268.938 -120.793C351.078 -187.844 435.169 -240.584 504.711 -271.653C539.486 -287.189 570.595 -297.293 595.986 -301.07C621.396 -304.849 640.941 -302.274 652.769 -292.62C664.596 -282.965 667.751 -267.01 663.121 -246.267C658.494 -225.54 646.116 -200.146 627.084 -171.76C589.024 -114.992 524.416 -46.348 442.276 20.7032C360.136 87.7543 276.045 140.494 206.502 171.563C171.727 187.099 140.618 197.204 115.227 200.98C89.8162 204.76 70.2708 202.185 58.4432 192.53C46.6158 182.875 43.4614 166.92 48.0918 146.178C52.7186 125.451 65.097 100.056 84.1291 71.6697C122.19 14.9017 186.798 -53.7418 268.938 -120.793Z",
    stroke: "url(#paint1_linear_342_330)",
    strokeOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 375.713,
    cy: 73.8007,
    rx: 375.713,
    ry: 73.8007,
    transform: "matrix(0.77467 -0.632366 0.77467 0.632366 219.766 130.919)",
    fill: "#A578FC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M511.207 -106.353C591.562 -171.947 670.697 -226.1 733.676 -260.629C765.169 -277.895 792.598 -290.241 814.106 -296.663C824.861 -299.874 834.106 -301.594 841.62 -301.719C849.134 -301.845 854.853 -300.376 858.657 -297.272C862.46 -294.167 864.259 -289.498 864.105 -283.364C863.951 -277.231 861.844 -269.684 857.911 -260.904C850.045 -243.348 834.92 -220.957 813.768 -195.25C771.469 -143.84 705.129 -79.241 624.774 -13.647C544.419 51.947 465.284 106.1 402.305 140.629C370.812 157.896 343.383 170.242 321.875 176.663C311.12 179.874 301.875 181.594 294.361 181.719C286.847 181.845 281.128 180.377 277.324 177.272C273.521 174.167 271.722 169.498 271.876 163.365C272.029 157.231 274.136 149.684 278.07 140.905C285.936 123.348 301.061 100.958 322.213 75.2498C364.512 23.8399 430.852 -40.7587 511.207 -106.353Z",
    stroke: "url(#paint2_linear_342_330)",
    strokeOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 375.713,
    cy: 97.0276,
    rx: 375.713,
    ry: 97.0276,
    transform: "matrix(0.941732 -0.336363 0.518113 0.855312 657.125 318.332)",
    fill: "#53D1FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1011.21 192.384C1108.88 157.496 1202.92 135.204 1275.99 127.358C1312.53 123.435 1343.8 123.127 1367.64 126.65C1391.52 130.177 1407.77 137.516 1414.57 148.737C1421.36 159.957 1418.2 174.229 1406.33 190.526C1394.48 206.798 1374.03 224.962 1346.58 243.894C1291.69 281.753 1208.91 322.618 1111.23 357.506C1013.55 392.394 919.513 414.686 846.442 422.532C809.903 426.455 778.637 426.762 754.793 423.24C730.914 419.712 714.664 412.373 707.867 401.153C701.07 389.932 704.229 375.661 716.1 359.364C727.952 343.092 748.402 324.928 775.85 305.997C830.74 268.138 913.528 227.271 1011.21 192.384Z",
    stroke: "url(#paint3_linear_342_330)",
    strokeOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5H1111C1121.77 0.5 1130.5 9.23045 1130.5 20V180C1130.5 190.77 1121.77 199.5 1111 199.5H20C9.23045 199.5 0.500006 190.77 0.5 180V20C0.500002 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "url(#paint4_linear_342_330)",
    strokeOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_342_330",
    x: -154.499,
    y: -503.185,
    width: 1773.14,
    height: 1129.33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_342_330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_342_330",
    x1: 491.917,
    y1: -93.7225,
    x2: 596.868,
    y2: 39.0746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_342_330",
    x1: 268.55,
    y1: -121.109,
    x2: 407.801,
    y2: 49.4776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_342_330",
    x1: 510.819,
    y1: -106.669,
    x2: 602.267,
    y2: 5.35802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_342_330",
    x1: 1010.95,
    y1: 191.956,
    x2: 1074.9,
    y2: 371.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bg.78deb6ba78cca651e7ca4e03491ccd35.svg";